export const LABEL_PRESETS = [
  { value: "152x102", label: "152 × 102 mm  (4×6\" Thermal)", width_mm: 152, height_mm: 102 },
  { value: "100x100", label: "100 × 100 mm  (Square)", width_mm: 100, height_mm: 100 },
  { value: "a4", label: "210 × 297 mm  (A4)", width_mm: 210, height_mm: 297 },
  { value: "custom", label: "Custom size (mm)", width_mm: 150, height_mm: 100 },
];

export const getPresetByValue = (value) =>
  LABEL_PRESETS.find((p) => p.value === value) || LABEL_PRESETS[0];

export const defaultLabelSize = () => ({
  preset: "152x102",
  width_mm: 152,
  height_mm: 102,
});

export const STATUS_OPTIONS = [
  "Pending",
  "Received in Origin Warehouse",
  "Departed from Origin Port",
  "In Transit",
  "Expected ETA",
  "Under Clearance",
  "Arrived at Destination",
  "Released",
  "Delivered",
];

export const CURRENCIES = ["USD", "CNY", "INR", "AED", "EUR"];

export const STATUS_COLOR = {
  Pending: "bg-zinc-100 text-zinc-700 border-zinc-300",
  "Received in Origin Warehouse": "bg-amber-50 text-amber-800 border-amber-300",
  "Departed from Origin Port": "bg-indigo-50 text-indigo-800 border-indigo-300",
  "In Transit": "bg-blue-50 text-blue-800 border-blue-300",
  "Expected ETA": "bg-violet-50 text-violet-800 border-violet-300",
  "Under Clearance": "bg-orange-50 text-orange-800 border-orange-300",
  "Arrived at Destination": "bg-teal-50 text-teal-800 border-teal-300",
  Released: "bg-emerald-50 text-emerald-800 border-emerald-300",
  Delivered: "bg-green-50 text-green-800 border-green-300",
};
